import { render, staticRenderFns } from "./kyc-fill-dialog.vue?vue&type=template&id=0fdb5d57"
import script from "./kyc-fill-dialog.vue?vue&type=script&lang=js"
export * from "./kyc-fill-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports